import { Field, Form } from 'formik';
import styled from 'styled-components';
import { TextRegular } from '../../styles/GlobalStyledComponents';
import {
  setBorder,
  setBorderWithCondition,
  setMobileBorder,
} from '../../utils/formInputHelper';
import { colors } from '../../styles/Colors';
import { FormFloating, FormInput } from '../../styles/FormStyledComponents';
import downArrow from '../../assets/icons/down-arrow.svg';

export interface FormLabelProps {
  $error?: string;
  $emptyvalue?: string;
  $position?: any;
  $identifier?: string;
}

export interface LaborDataSectionProps {
  $isHidden?: string;
}

export const LaborDataSection = styled.div<LaborDataSectionProps>`
  min-height: 180px;
  display: ${(props) => (props.$isHidden ? 'none' : 'block')};
`;

export interface AddressSectionProps {
  $isHidden?: string;
}

export const AddressSection = styled.div<AddressSectionProps>`
  min-height: 180px;
  display: ${(props) => (props.$isHidden ? 'none' : 'block')};
`;

export const AddressFormStyle = styled.div`
  input {
    text-transform: uppercase;
  }
`;

export const HousewifeInfo = styled(TextRegular)`
  margin: 0;
  padding: 5px 0 0 14px;
`;

export const FormPart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const StyledForm = styled(Form)`
  display: contents;
`;
export interface FormDataProps {
  $customWidth?: string;
}

export const FormNumber = styled.div<FormDataProps>`
  width: ${(props) => (props.$customWidth ? props.$customWidth : '25%')};
  position: relative;
  @media (max-width: 450px) {
    width: ${(props) =>
      props.$customWidth === '25%' ? props.$customWidth : '50%'};
  }
`;

export const FormPostalCode = styled.div<FormDataProps>`
  width: ${(props) => (props.$customWidth ? props.$customWidth : '30%')};
  position: relative;
  @media (max-width: 450px) {
    width: ${(props) =>
      props.$customWidth === '30%' ? props.$customWidth : '50%'};
  }
`;

export const FormData = styled.div<FormDataProps>`
  width: ${(props) => (props.$customWidth ? props.$customWidth : '75%')};
  position: relative;
  @media (max-width: 450px) {
    width: ${(props) =>
      props.$customWidth === '75%' || props.$customWidth === '70%'
        ? props.$customWidth
        : '100%'};
  }
`;

export const FormInputNumber = styled(Field)`
  color: ${colors.gray0};
  background-color: #fafafa;
  border: ${(props) =>
    props.error
      ? `1px solid ${colors.red5}`
      : `1px solid ${props.theme.colors.border}`};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  background-clip: padding-box;
  display: block;
  width: 100%;
  height: calc(3.5rem + 2px);
  padding: 1rem 0.75rem;
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  text-transform: uppercase;
  outline: none;
  appearance: none;
  background-image: ${(props) =>
    props.component === 'select' &&
    `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`};
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
  border-radius: ${(props) => (props.name ? setBorder(props.name) : '0')};
  @media (max-width: 450px) {
    border-radius: ${(props) =>
      props.identifier === 'nie' || props.position === 'upper'
        ? setBorderWithCondition(props.name)
        : setMobileBorder(props.name)};
  }
`;

export interface FormInputDataProps {
  $position?: string;
}

export const FormInputData = styled(FormInputNumber)`
  border-radius: ${(props) =>
    props.$position
      ? setBorderWithCondition(props.name, props.$position)
      : '0'};
`;

export const FormInputLabelData = styled.label<FormLabelProps>`
  transform: ${(props) =>
    props.$emptyvalue
      ? 'none'
      : 'scale(.85) translateY(-0.5rem) translateX(0.15rem)'};
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition:
    opacity 0.1s ease-in-out,
    transform 0.1s ease-in-out;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) =>
    props.$error ? `${colors.red5}` : `${colors.gray8}`}!important;
  opacity: 1 !important;
`;

export const FormInputLabelNumber = styled(FormInputLabelData)`
  left: 0px;
`;

export const AddressDetailSection = styled.div``;

export interface FormAddressProps {
  $customWidth?: string;
}

export const FormAddressRow = styled.div<FormAddressProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: ${(props) => (props.$customWidth ? props.$customWidth : '100%')};
`;

interface FormFloatingRowProps {
  $customWidth?: string;
}

export const FormFloatingRow = styled(FormFloating)<FormFloatingRowProps>`
  width: ${(props) => (props.$customWidth ? props.$customWidth : '100%')};
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const FormSelect = styled(FormInput)`
  min-width: 150px;
  padding-right: 1.5rem;
  background-image: ${(props) =>
    props.component === 'select' ? `url("${downArrow}")` : 'none'};
  background-size: 0.75rem;
  cursor: pointer;
`;

export const HandAddressSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`;

export const IconImg = styled.img`
  width: 18px;
  height: 18px;
`;

export const HandAddressButton = styled.button`
  color: ${colors.red6};
  background-color: transparent;
  border: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;
